<template>
  <dr-wrapper v-bind="$props" v-on="wrapOn">
    <v-sheet height="64">
        <v-toolbar flat color="white">
          <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
            {{ $t('drCalendarWidget.toDay') }}
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
            {{ parsMonth($refs.calendar) }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                outlined
                color="grey darken-2"
                v-bind="attrs"
                v-on="on"
              >
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(label, index) in typeToLabel" :key="index" @click="type = index">{{label}}</v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :type="model.Type"
          :weekdays="weekdays"
          :weekday-format="weekdayFormat"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
        ></v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card
            color="grey lighten-4"
            min-width="350px"
            max-width="700px"
            flat
            v-if="selectedEvent.detail"
          >
            <v-toolbar
              :color="selectedEvent.color"
              dark
            >
              <v-toolbar-title v-html="selectedEvent.detail.title"></v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <span class="text--primary" v-html="selectedEvent.detail.descrition"></span>
              <p class="subtitle-1 my-0 pt-2">{{ $t("drCalendarWidget.links") }}</p>
              <ul class="text--primary">
                <li class="aval-calendar-list pt-2" v-for="(item, index) in selectedEvent.detail.links" :key="index" >
                  <v-icon>mdi-link</v-icon><a class="text-decoration-none pl-1" :href="item.url">{{item.name}}</a>
                </li>
              </ul>
            </v-card-text>

          </v-card>
        </v-menu>
      </v-sheet>
  </dr-wrapper>
</template>
<script>
import moment from 'moment'

import baseMixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import inputMixin from '../../mixins/input-mixin'
import uk from '../../langs/drCalendar/uk.json'
import ru from '../../langs/drCalendar/ru.json'
import en from '../../langs/drCalendar/en.json'

export default {
  name: 'dr-calendar',
  mixins: [inputMixin, baseMixin, widgetsWrapperMixin],
  props: ['model'],
  data: () => ({
    focus: '',
    type: 'month',
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    weekdays: [1, 2, 3, 4, 5, 6, 0]
  }),
  i18n: {
    messages: {
      uk,
      en,
      ru
    }
  },
  computed: {
    events() {
      let events = this.getDataSourceField(this.model.Events)

      if (typeof events === 'string' || events.length === 0) {
        return []
      }

      events.forEach(e => {
        e.start = moment(e.start , 'DD.MM.YYYY hh:mm:ss').toDate()
        
        e.end = moment(e.end , 'DD.MM.YYYY hh:mm:ss').toDate()
      })
      return events
    },
    typeToLabel () {
      return {
        month: this.$t('drCalendarWidget.typeToLabel.month'),
        week: this.$t('drCalendarWidget.typeToLabel.week'),
        day: this.$t('drCalendarWidget.typeToLabel.day')
      }
    }
  },
  mounted() {
    // Для начального отображения месяца и года "Июнь 2020"
    this.$forceUpdate()
  },
  methods: {
    weekdayFormat(event) {
      return this.$t(`drCalendarWidget.days.${event.weekday}`)
    },
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor (event) {
      return event.color
    },
    setToday () {
      this.focus = ''
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        setTimeout(() => this.selectedOpen = true, 10)
      }
      if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },

    parsMonth(ref) {
      return `${this.$t(`drCalendarWidget.month.${ref._data.times.now.month}`)} ${ref._data.times.now.year}`
    }
  }
}
</script>
<style >
  .aval-calendar-list {
    list-style-type: none
  }
</style>
